import * as React from "react";
import i18n from "i18n";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  withStyles,
  CircularProgress,
} from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";

import { CompositionStore } from "modules/composition/CompositionStore";

import TaskRows from "modules/composition/components/layouts/TaskRow";
import { formatNumber } from "utils/MathUtils";

const styles = (theme) => ({
  container: {
    backgroundColor: "#f2f2f2",
    padding: "20px",
    height: "-webkit-fill-available",
    overflowY: "auto" as any,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "auto 1fr",
  },
  linearProgress: {
    backgroundColor: "unset",
    color: "#ABC200",
    margin: "0 auto",
  },
  table: {
    marginTop: "20px",
    width: "100%",
    border: 0,
    borderCollapse: "collapse" as any,
    "& tr": {
      display: "flex",
    },
    "& td": {
      padding: "10px",
      flex: "2",
      width: "1px",
      "&:first-child": {
        flex: "1",
      },
    },
    "& thead tr:after": {
      content: "" as any,
      overflowY: "scroll" as any,
      visibility: "hidden" as any,
      height: 0,
    },
    "& thead th": {
      flex: "2",
      display: "block",
      padding: "4px 10px 4px 10px",
      "&:first-child": {
        flex: "1",
      },
    },
    "& tbody": {
      display: "block",
      width: "100%",
      overflowY: "auto" as any,
      height: "450px",
    },
  },
  rateTask: {
    border: "0px",
    backgroundColor: "unset",
  },
  rateTaskCell: {
    border: "0px",
    fontFamily: "Roboto",
    fontSize: "12px",
    color: "#212121",
    fontWeight: 500,
  },
  button: {
    padding: "0px",
  },
  taskCellLoader: {
    height: "400px",
    verticalAlign: "middle",
    textAlign: "center" as any,
  },
  link: {
    color: "#000",
    height: "48px",
    padding: "12px",
  },
  header: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 400,
    color: "#a1a1a1",
    backgroundColor: "unset",
    whiteSpace: "nowrap" as any,
  },
  task: {
    backgroundColor: "#ffffff",
  },
  taskCell: {
    padding: "5px 20px",
    lineHeight: "17px",
    fontFamily: "Roboto",
    fontSize: "12px",
    color: "#5c5c5c",
    fontWeight: 400,
    display: "flex",
    alignItems: "center",
    "&:last-child": {
      width: "128px",
    },
  },
  taskLink: {
    color: "#41A0FF",
    fontWeight: 700,
  },
  iconMenu: {
    fontSize: 22,
    color: "#757575",
  },
  buttons: { padding: "10px" },
  inputCell: {
    fontFamily: "Roboto",
    fontSize: "12px",
    padding: "0px",
    marginTop: "10px",
    marginBottom: "1px",
    whiteSpace: "nowrap" as any,
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "70px",
    textAlign: "right" as any,
    "&::after": {
      borderBottom: "1px dashed !important",
    },
  },
});

type IProps = {
  classes: any;
  _reloadComponent: any;
};

@observer
class TaskContent extends React.Component<IProps> {
  state = {
    loaded: false,
    pathStringTaskId: "",
    btnEdit: false,
    hasAlternativeCode: false,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount(): void {
    const _locationArray = location.pathname.split("/");
    this.setState({
      pathStringTaskId: _locationArray[_locationArray.length - 1],
    });
  }

  componentDidUpdate(): void {
    const _locationArray = location.pathname.split("/");
    if (
      _locationArray[_locationArray.length - 1] != this.state.pathStringTaskId
    ) {
      this.setState({
        pathStringTaskId: _locationArray[_locationArray.length - 1],
      });
      this._setScroll();
    }
  }

  verifyAlternativeCode() {
    for (let i = 0; i < CompositionStore.rateTasks.length; i++) {
      const element = CompositionStore.rateTasks[i];
      if (
        element.data.alternativeCodeComposition ||
        element.data.alternativeCodeItem
      ) {
        this.setState({ hasAlternativeCode: true });
        break;
      }
    }
  }

  // Função que pega a posição do scroll salvo na variável compositionGroupScrollTop e seta na tabela
  _setScroll() {
    const scroller = document.querySelector("#getScrollTask");
    if (scroller) {
      if (CompositionStore.loading === false) {
        setTimeout(() => {
          let locationArray = location.pathname.split("/");
          if (locationArray.length > 2) {
            if (
              locationArray[locationArray.length - 1] ==
              this.state.pathStringTaskId
            ) {
              scroller.scrollTop =
                CompositionStore.getCompositionGroupScrollTopObj(
                  this.state.pathStringTaskId
                );
            }
          }
        }, 100);
      }
    }
  }

  render() {
    if (this.state.hasAlternativeCode == false) {
      this.verifyAlternativeCode();
    }
    const { classes, _reloadComponent } = this.props,
      { rateTask } = CompositionStore;
    let stringPath = "/" + location.pathname.split("/").slice(1, -1).join("/");
    let run = false,
      parentHasAlternativeCode =
        rateTask &&
        (rateTask.data.alternativeCodeComposition ||
          rateTask.data.alternativeCodeItem),
      cont = 0;
    const alterarBtnEdit = () => {
      this.setState({ btnEdit: !this.state.btnEdit });
    };

    // Função que pega a posição do scroll da tabela e passa para a variável compositionGroupScrollTop
    const getScroll = () => {
      const scroller = document.querySelector("#getScrollTask");
      if (scroller) {
        setTimeout(() => {
          scroller.addEventListener("scroll", (event: any) => {
            let locationArray = location.pathname.split("/");
            if (locationArray.length > 2) {
              CompositionStore.setCompositionGroupScrollTopObj(
                locationArray[locationArray.length - 1],
                scroller.scrollTop
              );
            }
          });
        }, 1100);
      }
    };

    return (
      rateTask && (
        <div className={classes.container}>
          <div className={classes.grid}>
            <div>
              <IconButton className={classes.button}>
                <Link
                  to={stringPath}
                  className={classes.link}
                  onClick={() => (CompositionStore.loading = false)}
                >
                  <ArrowBack />
                </Link>
              </IconButton>
            </div>
            <Table>
              <TableBody>
                <TableRow className={classes.rateTask}>
                  <TableCell className={classes.rateTaskCell}>
                    {rateTask.data.description}
                  </TableCell>
                  {parentHasAlternativeCode && (
                    <TableCell className={classes.rateTaskCell}>
                      {rateTask.data.alternativeCodeItem
                        ? rateTask.data.alternativeCodeItem
                        : rateTask.data.alternativeCodeComposition}
                    </TableCell>
                  )}
                  <TableCell className={classes.rateTaskCell}>
                    {rateTask.data.unity}
                  </TableCell>
                  <TableCell className={classes.rateTaskCell} numeric>
                    {rateTask.data.totalCost
                      ? formatNumber(rateTask.data.totalCost)
                      : formatNumber("0.0")}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
          <Table className={classes.table}>
            <TableHead className={classes.header}>
              <TableRow style={{ display: "flex-row" }}>
                <TableCell className={classes.taskCell} style={{ flex: 1 }}>
                  {i18n.rateLibraries.header.code}
                </TableCell>
                {this.state.hasAlternativeCode && (
                  <TableCell
                    className={classes.taskCell}
                    numeric
                    style={{ flex: 2 }}
                  >
                    {i18n.rateLibraries.header.alternativeCode}
                  </TableCell>
                )}
                <TableCell>{i18n.rateLibraries.header.description}</TableCell>
                <TableCell
                  className={classes.taskCell}
                  numeric
                  style={{ flex: 24 }}
                >
                  {i18n.rateLibraries.header.unity}
                </TableCell>
                <TableCell
                  className={classes.taskCell}
                  numeric
                  style={{ flex: 2 }}
                >
                  {i18n.rateLibraries.header.quantity}
                </TableCell>
                <TableCell
                  className={classes.taskCell}
                  numeric
                  style={{ flex: 2 }}
                >
                  {i18n.rateLibraries.header.unitCost}
                </TableCell>
                <TableCell
                  className={classes.taskCell}
                  numeric
                  style={{ flex: 2 }}
                >
                  {i18n.rateLibraries.header.totalCost}
                </TableCell>
                {!CompositionStore.benchComposition.data.publicLibrary && ( // Se o banco de composição for uma biblioteca publica ele exibe a colina de edição
                  <TableCell
                    className={classes.taskCell}
                    numeric
                    style={{ flex: 2 }}
                  />
                )}
              </TableRow>
            </TableHead>
            <TableBody id="getScrollTask">
              {CompositionStore.loading === false ? (
                ((cont = 0),
                (run = false),
                CompositionStore.rateTasks.forEach((el, index, array) => {
                  if (el.id == CompositionStore.rateTask.id) cont++;
                  if (index == array.length - 1) {
                    if (cont == 0) run = true;
                  }
                }),
                getScroll(),
                run &&
                  CompositionStore.rateTasks.map((item) => {
                    let textTotal = item.data.finalCost
                      ? formatNumber(item.data.finalCost)
                      : formatNumber("0.0");
                    let textUnit = item.data.totalCost
                      ? formatNumber(item.data.totalCost)
                      : formatNumber(item.data.unityCost);
                    return (
                      <TaskRows
                        item={item}
                        textTotal={textTotal}
                        textUnit={textUnit}
                        rateTask={rateTask.id}
                        classes={classes}
                        btnEdit={this.state.btnEdit}
                        hasAlternativeCode={this.state.hasAlternativeCode}
                        alterarBtnEdit={alterarBtnEdit}
                        _reloadComponent={_reloadComponent} // Passando a função pra o componente
                      />
                    );
                  }))
              ) : (
                <TableRow className={classes.task}>
                  <TableCell colSpan={5} className={classes.taskCellLoader}>
                    <CircularProgress
                      size={96}
                      className={classes.linearProgress}
                      variant="indeterminate"
                    />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      )
    );
  }
}

export default withStyles(styles)(TaskContent);



// WEBPACK FOOTER //
// ./src/modules/composition/components/layouts/TaskContent.tsx